/**
 * @file intl-util.ts
 *
 * @fileoverview this file exports utility functions for intl configuration.
 */

/**
 * Returns locale format for intl.
 *
 * @param runtimeConfiguration
 *   Runtime configuration.
 *
 * @return {string}
 *   The abbreviation to use for locale configuration.
 */
export const getIntlLocale = (
  currentLocale,
  { APP: { FORMAT_MAP } },
): string => {
  const locale = FORMAT_MAP?.[currentLocale]?.localeFormat;

  if (locale) {
    return locale;
  } else {
    return currentLocale;
  }
};

/**
 * Handles intl error.
 * Checks missing translation error.
 */
export const handleIntlError = (error) => {
  if (error.code === 'MISSING_TRANSLATION') {
    // console.warn('Missing translation', error.message);
    return;
  }
};
